import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Layout from '../layout.vue'
import BlankLayout from '../../layout/blankLayout.vue'
import List from './list.vue'
import Editor from './editor.vue'

const basePath = '/v-admin/job-template/management'

export default {
  path: `${basePath}`,
  component: BlankLayout,
  meta: {
    isAllInclude: true,
    menu: {
      get label () {
        return i18n.t('admin.company.jobTemplateManagement.menu')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      name: 'jobTemplateManagement',
      path: `${basePath}`,
      redirect: `${basePath}/list`,
      component: Layout,
      meta: {
        breadcrumb: { hidden: true },
        permission: 'PERM_ADMIN_JOB_TEMPLATE',
        titleI18nKey: 'admin.company.jobTemplateManagement.title'
      },
      children: [
        {
          name: 'jobTemplateList',
          path: `${basePath}/list`,
          component: List,
          meta: {
            isNewPage: true,
            breadcrumb: { hidden: true },
            permission: 'PERM_ADMIN_JOB_TEMPLATE',
            titleI18nKey: 'admin.company.jobTemplateManagement.title'
          }
        }
      ]
    },
    {
      name: 'addJobTemplate',
      path: `${basePath}/add`,
      component: Editor,
      meta: {
        isEditMode: false,
        titleI18nKey: 'admin.job.editor.title.addTemplate',
        hiddenAsideMenu: true
      }
    },
    {
      name: 'editJobTemplate',
      path: `${basePath}/edit/:jobTemplateId`,
      component: Editor,
      meta: {
        isEditMode: true,
        titleI18nKey: 'admin.job.editor.title.editTemplate',
        hiddenAsideMenu: true
      }
    }
  ]
}
